import { useCallback, useReducer } from 'react'

export const collapseKey = {
  account: 'account',
  note: 'note',
}

export const ActionType = {
  TOGGLE_COLLAPSE_ACCOUNT: 'TOGGLE_COLLAPSE_ACCOUNT',
  TOGGLE_COLLAPSE_NOTE: 'TOGGLE_COLLAPSE_NOTE',
}

const initialState = {
  account: true,
  note: true,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.TOGGLE_COLLAPSE_ACCOUNT:
      return {
        account: !state.account,
      }
    case ActionType.TOGGLE_COLLAPSE_NOTE:
      return {
        note: !state.note,
      }

    default:
      return state
  }
}

export default function useAccountInfo() {
  const [state, dispatch] = useReducer(reducer, initialState)

  const toggleCollapse = useCallback((collapseKey) => {
    switch (collapseKey) {
      case collapseKey.account:
        dispatch({
          type: ActionType.TOGGLE_COLLAPSE_ACCOUNT,
        })
        break
      case collapseKey.note:
        dispatch({
          type: ActionType.TOGGLE_COLLAPSE_NOTE,
        })
        break

      default:
        break
    }
  }, [])

  return {
    state,
    toggleCollapse,
  }
}
